import { useQuery } from "@tanstack/react-query";
import { billing } from "@/lib/billing";
import { useAuth } from "@/context/AuthContext";

export function useSubscription() {
  const { user } = useAuth();
  const query = useQuery({
    queryKey: ["pro-subscription"],
    queryFn: async () => (await billing.get("/subscription/status")).data,
    enabled: user?.role === "professional",
    staleTime: 30_000,
    retry: 1,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
  return { ...query, isPro: !!query.data?.pro_active };
}
